/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { BreadCrumb } from '../components/BreadCrumb';
import { NavBar } from '../components/NavBar';
import { Sidebar } from '../components/Sidebar';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { useMsal } from '@azure/msal-react';
import { Button } from 'primereact/button';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Dialog } from 'primereact/dialog';
import personiaLogo from '../assets/img/Logo_CONTPAQi_Colabora.png';
import useCompanySetting from '../hooks/company/useCompanySetting';
import useVerifyLicense from '../hooks/company/useVerifyLicense';
import useAccess from '../hooks/access/useAccess';
import { useIntegrations } from '../hooks/integrations/useIntegrations';
import { StoreContext } from '../business/Provider';
import { FullLoading } from '../components/FullLoading';
export const MainLayout = () => {
	const { getCompanySettings, syncIncidentTypesAsAbsenceTypes } = useCompanySetting();
	const { verifyLicense } = useVerifyLicense();
	const { getAccessRole } = useAccess();
	const { instance } = useMsal();

	const [showPopover, setShowPopover] = useState(false);
	const [showCloseDialog, setShowCloseDialog] = useState(false);
	const [isExpand, setIsExpand] = useState(false);
	const refCloseProfileCard = useRef(null);
	const [showDialog, setShowDialog] = useState(false);
	const [wUl, setWUl] = useState(' w-[90px] ');
	const { stateCompanyDataSettings, getAccessRoleState } = useContext(StoreContext);
	const [retry, setRetry] = useState(0);

	const [isVerifyingLicense, setIsVerifyingLicense] = useState(true);
	const [canRenderLayout, setCanRenderLayout] = useState(false);


	const { postIntegrations } = useIntegrations();

	const renderToastContainer = () => {
		return (
			<ToastContainer
				position='bottom-right'
				autoClose={5000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
				theme='light'
			/>
		);
	};

	useEffect(() => {
		const fetchData = async () => {
			let keepBlockingScreen = false;

			try {
				setIsVerifyingLicense(true);
				setCanRenderLayout(false);

				const isValidLicense = await verifyLicense();

				if (!isValidLicense) {
					setCanRenderLayout(false);

					keepBlockingScreen = true;

					return;
				}

				await Promise.all([getCompanySettings(), getAccessRole()]);

				setCanRenderLayout(true);
			} catch (error) {
				console.error('Error fetching data:', error);
				setCanRenderLayout(false);
			} finally {
				if (!keepBlockingScreen) {
					setIsVerifyingLicense(false);
				}
			}
		};

		fetchData();
	}, []);

 


	useEffect(() => {
		const executeIntegrations = async () => {
			if (!canRenderLayout) {
				return;
			}

			if (stateCompanyDataSettings.companies !== null) {
				const attendanceImportDetail =
					stateCompanyDataSettings?.companies?.attendanceImportDetail;
				const data = JSON.parse(attendanceImportDetail);

				const promises = [];

				if (
					data.Employees === undefined ||
					data.Employees === null ||
					!data.Employees
				) {
					promises.push(postIntegrations(203));
				}

				if (
					data.OrgChart === undefined ||
					data.OrgChart === null ||
					!data.OrgChart
				) {
					promises.push(postIntegrations(206));
				}

				// Espera a que todas las promesas se resuelvan
				if (promises.length > 0 && retry < 3) {
					await Promise.all(promises).finally(() => {
						anotherFunction();
					});
				}
				// Llama a la función después de que ambas promesas se hayan completado
			}
		};

		executeIntegrations();
	}, [stateCompanyDataSettings, canRenderLayout]);

	const anotherFunction = () => {
		return getCompanySettings();
	};

	useEffect(() => {
		if (showPopover) {
			const checkIfClickedOutside = (e) => {
				if (
					refCloseProfileCard.current &&
					!refCloseProfileCard.current.contains(e.target)
				) {
					setShowPopover(false);
				}
			};
			window.addEventListener('mousedown', checkIfClickedOutside);
			return () => {
				window.removeEventListener('mousedown', checkIfClickedOutside);
			};
		}
	}, [showPopover]);

	//ReEntryData

	const signOff = async () => {
		const currentAccount = instance.getAllAccounts()[0];
		instance.logoutRedirect({
			account: currentAccount,
		});
		sessionStorage.removeItem('sessionState');
		window.localStorage.clear();

		return null;
	};

	const renderFooterDialog = () => {
		return (
			<div>
				<Button
					label='SÍ, DESEO SALIR'
					icon='pi pi-check'
					onClick={() => {
						signOff();
						setShowCloseDialog(false);
					}}
					autoFocus
				/>
				<Button
					label='NO, PERMANECER AQUÍ'
					icon='pi pi-times'
					onClick={() => setShowCloseDialog(false)}
					className='p-button-text'
				/>
			</div>
		);
	};

	const closeDialog = () => {
		return (
			<ConfirmDialog
				footer={renderFooterDialog()}
				visible={showCloseDialog}
				onHide={() => setShowCloseDialog(false)}
				message='¿Estás seguro de que quieres terminar la sesión?'
				header='FINALIZAR SESIÓN'
				// acceptLabel='SÍ, DESEO SALIR'
				// rejectLabel='NO, PERMANECER AQUÍ'
				accept={() => signOff()}
				reject={() => setShowCloseDialog(false)}
			/>
		);
	};

	const renderFooter = () => {
		return (
			<div>
				<Button
					label='Ok'
					onClick={() => setShowDialog(false)}
					className='p-button-text'
				/>
			</div>
		);
	};

	const renderDialog = () => {
		return (
			<Dialog
				header='Acerca de'
				visible={showDialog}
				style={{ width: '30vw' }}
				footer={renderFooter()}
				onHide={() => setShowDialog(false)}>
				<div className='flex w-full h-full flex-col justify-center items-center content-center'>
					<div className='flex w-[125px] pl-1 justify-center item-center align-bottom m-auto'>
						<img
							className='object-scale-down w-full h-12'
							src={personiaLogo}
							alt='Logo'
						/>
					</div>
					<p>{'Liberación: ' + window.REACT_APP_RELEASE_VERSION}</p>
					<p>{'Compilación: ' + window.REACT_APP_BUILD_VERSION}</p>
				</div>
			</Dialog>
		);
	};

	if (isVerifyingLicense) {
		return (
			<>
				<div className='h-screen w-full relative'>
					<FullLoading
						loadingState={true}
						message='Validando licencia...'
					/>
				</div>
				{renderToastContainer()}
			</>
		);
	}

	if (!canRenderLayout) {
		return <>{renderToastContainer()}</>;
	}

	return (
		<div className='flex h-screen w-full flex-col overflow-hidden'>

			<NavBar
				showPopover={showPopover}
				setShowPopover={setShowPopover}
				refCloseProfileCard={refCloseProfileCard}
				closeFunction={setShowCloseDialog}
				setShowDialog={setShowDialog}
			/>
			<div className='flex w-full flex-grow flex-row relative'>
				<div className={'flex h-full relative  ' + wUl}>
					<Sidebar
						onClick={() => setIsExpand(!isExpand)}
						isExpand={isExpand}
						setWUl={setWUl}
					/>
				</div>

				{
					<div className='flex grow  flex-col relative'>
						<div className='flex h-[44px] w-full bg-white flex-row  drop-shadow-md'>
							<BreadCrumb />
						</div>
						<div className='flex w-full h-full '>
							<Outlet />
							{renderDialog()}
							{showCloseDialog && closeDialog()}
							{renderToastContainer()}
						</div>
					</div>
				}
			</div>
		</div>
	);
};
